import PropTypes from 'prop-types'
import React, { memo, useCallback, useEffect, useRef, useState } from 'react'
// Component
import PopupNotificationPage from '../../pages/PopupNotificationPage/PopupNotificationPage'
// Styled Component
import {
  ListWrapper,
  NotificationItem,
  ViewAll,
} from '../../layouts/DashboardLayout/DashboardLayoutStyled'
import { NotiWrapper } from '../MainSidebar/MainSidebarStyled'
// Ant design
import {
  BellFilled,
  CloseOutlined,
  LogoutOutlined,
  UserOutlined,
} from '@ant-design/icons'
import {
  Alert,
  Avatar,
  Badge,
  Dropdown,
  Space,
  Menu,
  Select,
  Tabs,
  Tooltip,
  message,
  Button,
} from 'antd'
// firebase
import firebase from 'firebase/app'
import 'firebase/messaging'
// Other
import { useKeycloak } from '@react-keycloak/web'
import { inject, observer } from 'mobx-react'
import queryString from 'query-string'
import { withRouter } from 'react-router-dom'
import { blue } from '../../color'
import {
  envName,
  prefix,
  useSSO,
  vapidKey,
  version,
  systemName,
  apiUrl,
} from '../../config'
import { NOTIFICATION_STATUS } from '../../constants'
import utils from '../../utils'
import EmptyContent from '../EmptyContent'
import PopupAppGrid from '../PopupAppGrid/PopupAppGrid'
import { FaRocketchat } from 'react-icons/fa'
import { ChatBot } from '../ChatBot'
import Marquee from './Marquee'
import SimpleBreadCrumbV2 from '../SimpleBreadCrumb/SimpleBreadCrumbV2'
import {
  AltArrowDownOutlineIcon,
  ArrowRightOutlineIcon,
  BellLinearIcon,
} from '../AppIcon'

const { TabPane } = Tabs

const MainHeaderBar = props => {
  const messaging = firebase.messaging.isSupported()
    ? firebase.messaging()
    : null

  const {
    authenticationStore,
    accountStore,
    history,
    companyStore,
    userStore,
    notificationStore,
  } = props

  const { unreadNotificationCount, unreadNewsCount } = notificationStore
  const {
    currentUserAvatar,
    currentUser,
    mustChangePassword,
    isAccountAdmin,
    isSuperAdmin,
  } = authenticationStore

  const { companyList } = companyStore
  const [visibleNotification, setVisibleNotification] = useState(false)
  const [visibleTest, setVisibleTest] = useState(false)
  const [changedTabsNotification, setChangedTabsNotification] = useState({
    status: false,
    onlyNewsNotification: false,
    isOpen: false,
  })

  const { Option } = Select

  const disabledKeyCloak = {
    keycloak: null,
  }
  const { keycloak, initialized } = useSSO ? useKeycloak() : disabledKeyCloak

  const clickLogout = useCallback(() => {
    accountStore.clearStore()
    companyStore.clearStore()
    userStore.clearStore()
    notificationStore.clearStore()
    authenticationStore.userLogout()

    if (keycloak) {
      keycloak.logout()
    }

    if (!useSSO) {
      history.replace('/')
    }

    messaging
      ?.deleteToken()
      .then(res => console.log(res))
      .catch(err => console.log(err))
  }, [])

  useEffect(() => {
    if (!localStorage.getItem('FCMToken')) {
      messaging
        ?.getToken({ vapidKey: vapidKey })
        .then(currentToken => {
          if (currentToken) {
            localStorage.setItem('FCMToken', JSON.stringify(currentToken))
            notificationStore
              .sendTokenToSever(currentToken)
              .then(res => console.log(res))
              .catch(err => console.log(err.vi))
          } else {
            console.log(
              'No registration token available. Request permission to generate one.'
            )
          }
        })
        .catch(() => console.log('You have blocked notifications!'))
    }
    messaging?.onMessage(async payload => {
      console.log('Message received. ', payload)
      if (payload.data.type === NOTIFICATION_STATUS.NEWS) {
        if (changedTabsNotification.isOpen) {
          setChangedTabsNotification({
            status: true,
            onlyNewsNotification: true,
            isOpen: true,
          })
        } else {
          await notificationStore.getUnreadNewsCount()
        }
      } else {
        if (changedTabsNotification.isOpen) {
          setChangedTabsNotification({
            status: true,
            onlyNewsNotification: false,
            isOpen: true,
          })
        } else {
          await notificationStore.getUnreadNotificationCount()
        }
      }
      notificationStore.setNotificationType(payload.data.type)
      message.info(`Thông báo mới: ${payload.notification.body}`)
    })
  }, [changedTabsNotification])

  useEffect(() => {
    if (!utils.isIOSDevice()) {
      const channel4Broadcast = new BroadcastChannel('channel4')
      channel4Broadcast.onmessage = async even => {
        if (even.data.type === NOTIFICATION_STATUS.NEWS) {
          if (changedTabsNotification.isOpen) {
            setChangedTabsNotification({
              status: true,
              onlyNewsNotification: true,
              isOpen: true,
            })
          } else {
            await notificationStore.getUnreadNewsCount()
          }
        } else {
          if (changedTabsNotification.isOpen) {
            setChangedTabsNotification({
              status: true,
              onlyNewsNotification: false,
              isOpen: true,
            })
          } else {
            await notificationStore.getUnreadNotificationCount()
          }
        }
      }
    }
  }, [changedTabsNotification])

  const onCompanyChange = value => {
    userStore
      .updateCurrentUser({
        ...authenticationStore.currentUser,
        ...{ company_code: value },
      })
      .then(() => {
        authenticationStore.checkCurrentUser()
      })
  }

  const menu = (
    <Menu>
      <Menu.Item
        onClick={() => history.push('/my-profile/overview')}
        style={{ color: blue }}>
        <UserOutlined style={{ color: blue, marginRight: '5px' }} />
        Thông Tin Cá Nhân
      </Menu.Item>
      <Menu.Item onClick={() => clickLogout()} danger>
        <LogoutOutlined style={{ marginRight: '5px' }} />
        Đăng Xuất
      </Menu.Item>
    </Menu>
  )

  const onChangeTabsNotification = tab => {
    setChangedTabsNotification({
      status: true,
      onlyNewsNotification: tab === 'news',
      isOpen: true,
    })
  }

  const notiWrapper = (
    <NotiWrapper>
      <Tabs
        onChange={onChangeTabsNotification}
        defaultActiveKey="1"
        // tabBarExtraContent={
        //   <Tooltip title={'Đóng'}>
        //     <span
        //       className={'close-notification'}
        //       onClick={() => setVisibleNotification(false)}>
        //       <CloseOutlined />
        //     </span>
        //   </Tooltip>
        // }
      >
        <TabPane
          tab={
            <Badge
              count={
                unreadNotificationCount > 99 ? '99+' : unreadNotificationCount
              }>
              <span style={{ paddingRight: 13 }}>Thông báo</span>
            </Badge>
          }
          key="notification">
          <ListWrapper>
            <PopupNotificationPage
              changedTabsNotification={changedTabsNotification}
              onlyNewsNotification={false}
              visibleNotification={visibleNotification}
              setVisibleNotification={() => setVisibleNotification(false)}
            />
            <ViewAll
              onClick={() => {
                setVisibleNotification(false)
                const queryStringParams = queryString.stringify({
                  only_news_notification: false,
                })
                history.push(`/notification?${queryStringParams}`)
              }}>
              <a>Xem tất cả</a>{' '}
              <ArrowRightOutlineIcon
                style={{
                  width: 16,
                  height: 16,
                  cursor: 'pointer',
                  transform: 'rotate(-45deg)',
                }}
              />
            </ViewAll>
          </ListWrapper>
        </TabPane>
        <TabPane
          tab={
            <Badge count={unreadNewsCount > 99 ? '99+' : unreadNewsCount}>
              <span style={{ paddingRight: 13 }}>Thông báo chung</span>
            </Badge>
          }
          key="news">
          <ListWrapper>
            <PopupNotificationPage
              changedTabsNotification={changedTabsNotification}
              onlyNewsNotification={true}
              setVisibleNotification={() => setVisibleNotification(false)}
            />
            <ViewAll
              onClick={() => {
                setVisibleNotification(false)
                const queryStringParams = queryString.stringify({
                  only_news_notification: true,
                })
                history.push(`/notification?${queryStringParams}`)
              }}>
              <a>Xem tất cả</a>
              <ArrowRightOutlineIcon
                style={{
                  width: 16,
                  height: 16,
                  cursor: 'pointer',
                  transform: 'rotate(-45deg)',
                }}
              />
            </ViewAll>
          </ListWrapper>
        </TabPane>
      </Tabs>
    </NotiWrapper>
  )
  const fileInputRef = useRef(null)
  const [responseMessage, setResponseMessage] = useState('')
  const [activeAnotherBanner, setActiveAnotherBanner] = useState(false)
  const unreadTotalCount = unreadNewsCount + unreadNotificationCount
  const [showPasswordAlert, setShowPasswordAlert] = useState(true)
  const isTest =
    ['dev', 'stg', 'uat'].includes(envName) || apiUrl?.includes('fafu.com.vn')
  return (
    <>
      <div style={{ marginRight: 'auto' }}>
        <SimpleBreadCrumbV2 />
      </div>
      {/* <div className={'logo'}>
        <img
          onClick={() => history.push('/dashboard')}
          src={`${process.env.PUBLIC_URL}/assets/photos/portal_logo_white.png`}
          alt="VIMC logo"
          className="logoImg"
        />
      </div> */}
      {/* <div
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          gap: '8px',
          fontSize: '24px',
        }}>
        <span style={{ color: 'red' }}>{isTest ? version : ''}</span>
        <span style={{ color: 'red', textTransform: 'uppercase' }}>
          {isTest ? envName : ''}
        </span>
      </div> */}
      {/* {authenticationStore.currentUser?.is_admin && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: '10px',
          }}>
          <Select
            allowClear
            showSearch
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            style={{ width: 350 }}
            onChange={e => onCompanyChange(e)}
            value={authenticationStore?.currentUser?.company?.code}
            notFoundContent={<EmptyContent />}
            placeholder={'Chọn công ty'}>
            {companyList?.map(item => (
              <Option key={item.code} value={item.code}>
                {item.name}
              </Option>
            ))}
          </Select>
        </div>
      )} */}
      {/* <Alert
        message={
          <Marquee
            text={[
              'Chúc mừng Tổng công ty Hàng hải Việt Nam - CTCP đoạt danh hiệu TOP10 Giải thưởng Sao Vàng đất Việt năm 2024',
            ]}
            speed={15}
            direction="left"
          />
        }
        type="error"
        // showIcon
        closable
        onClose={() => {
          setShowPasswordAlert(false)
        }}
        style={{ marginRight: 10 }}
      /> */}

      {/* {mustChangePassword && (
        <Tooltip placement="top">
          <Alert
            message={
              <span>Mật khẩu của bạn đã quá hạn. Vui lòng đổi mật khẩu </span>
            }
            type="error"
            // showIcon
            closable
            onClose={() => {
              setShowPasswordAlert(false)
              // setActiveAnotherBanner(true)
            }}
            style={{ marginRight: 10 }}
          />
        </Tooltip>
      )} */}

      {/* {activeAnotherBanner && (
        <Alert
          message={
            <span>
              <Marquee
                text={[
                  'Chúc mừng Tổng công ty Hàng hải Việt Nam - CTCP đoạt danh hiệu TOP10 Giải thưởng Sao Vàng đất Việt năm 2024',
                ]}
                speed={15}
                direction="left"
              />
            </span>
          }
          type="error"
          // showIcon
          closable
          // onClose={() => setActiveAnotherBanner(false)}
          style={{ marginRight: 10 }}
        />
      )} */}
      {/* {mustChangePassword && showPasswordAlert && (
        <Tooltip title="Nhấp vào để đổi mật khẩu">
          <a
            style={{
              color: 'white',
              fontWeight: 600,
              textDecoration: 'underline',
              cursor: 'pointer',
              backgroundColor: 'transparent',
            }}
            href={`${
              process.env.REACT_APP_API_URL?.includes('localhost')
                ? 'http://localhost:3000'
                : process.env.REACT_APP_API_URL
            }/my-profile/change-password`}>
            Tại đây
          </a>
        </Tooltip>
      )} */}
      {/* <div style={{ visibility: 'hidden' }}>
        <Tooltip
          placement="top"
          style={{ display: 'none' }}
          title={'Giải đáp, tư vấn chính sách của người lao động'}>
          <a
            href="https://tcns.vimc.co/"
            target="_blank"
            className="sidebarItem avatar"
            style={{
              fontWeight: 500,
              fontSize: 14,
              textDecoration: 'underline',
            }}>
            Hỏi đáp chính sách
          </a>
        </Tooltip>
      </div> */}
      {/* {systemName === 'VIMC' && (
        <Tooltip
          placement="top"
          title={'Đánh giá Ban CMNV'}
          style={{ display: 'none' }}>
          <a
            href="https://danhgia.vimc.co/"
            target="_blank"
            className="sidebarItem avatar"
            style={{
              fontWeight: 500,
              fontSize: 14,
              textDecoration: 'underline',
            }}>
            Đánh giá Ban CMNV
          </a>
        </Tooltip>
      )} */}

      {/* <Tooltip placement="top" title={'Hướng dẫn sử dụng'}>
        <a
          href="https://cloud.vimc.co/s/SKDejCRwaAfk87T"
          target="_blank"
          className="sidebarItem avatar"
          style={{
            fontWeight: 500,
            fontSize: 14,
            textDecoration: 'underline',
          }}>
          Guide
        </a>
      </Tooltip> */}
      {/* <Tooltip placement="top" title={'Hỗ trợ'}>
        <a
          href="https://hotro.vimc.co"
          target="_blank"
          className="sidebarItem avatar"
          style={{
            fontWeight: 500,
            fontSize: 14,
            textDecoration: 'underline',
          }}>
          Support
        </a>
      </Tooltip> */}
      {/* {envName === 'uat' && (
        <NotificationItem showNotification={visibleTest}>
          <Tooltip placement="bottom" title={'Chat bot'}>
            <Dropdown
              overlay={<ChatBot />}
              placement="bottomRight"
              trigger={['click']}
              visible={visibleTest}
              onVisibleChange={flag => setVisibleTest(flag)}>
              <div
                style={{
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  margin: '5px 1px 0 10px',
                }}
                onClick={e => {
                  setVisibleTest(!visibleTest)
                  e.stopPropagation()
                }}>
                <div style={{ position: 'relative' }}>
                  <FaRocketchat
                    style={{ color: '#fff', fontSize: 18, marginLeft: '1px' }}
                  />
                </div>
              </div>
            </Dropdown>
          </Tooltip>
        </NotificationItem>
      )} */}
      {/* {systemName === 'VIMC' && <PopupAppGrid />} */}

      <div className="sidebarItem">
        <Dropdown
          overlay={notiWrapper}
          placement="bottomRight"
          trigger={['click']}
          visible={visibleNotification}
          onVisibleChange={flag => setVisibleNotification(flag)}>
          <div
            className={'notificationItemBox'}
            onClick={() => {
              if (!visibleNotification) {
                setChangedTabsNotification({
                  status: true,
                  onlyNewsNotification:
                    changedTabsNotification.onlyNewsNotification,
                  isOpen: true,
                })
              }
              setVisibleNotification(!visibleNotification)
              notificationStore.clearKeyword()
            }}>
            <div title="Thông báo">
              <Badge
                count={unreadTotalCount > 99 ? '99+' : unreadTotalCount}
                offset={[-5, -2]}
                style={{ fontSize: '10px' }}>
                <div className="notificationWrapper">
                  <BellLinearIcon
                    style={{
                      height: '20px',
                      width: '20px',
                      cursor: 'pointer',
                      color: '#000',
                    }}
                  />
                </div>
              </Badge>
            </div>
          </div>
        </Dropdown>
      </div>
      <div style={{ marginRight: 6 }}>
        <Dropdown
          overlay={menu}
          placement="topLeft"
          trigger={['click']}
          className="sidebarItem">
          <div
            title="Tài khoản"
            onClick={() => setVisibleNotification(false)}
            className="sidebarItem avatar">
            <div
              style={{
                display: 'flex',
                cursor: 'pointer',
                alignItems: 'center',
                justifyContent: 'flex-end',
                gap: '20px',
              }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}>
                <Avatar
                  size={44}
                  src={
                    currentUserAvatar && URL.createObjectURL(currentUserAvatar)
                  }
                />
                <div>
                  <div style={{ fontWeight: 500 }}>
                    {currentUser &&
                      utils.getNameInCapitalize(currentUser.name_uppercase)}
                  </div>
                  <div style={{ color: 'rgba(0,0,0,.4)' }}>
                    {!!currentUser?.position?.name &&
                      currentUser?.position?.name}
                  </div>
                </div>
              </div>
              <AltArrowDownOutlineIcon
                style={{
                  width: 20,
                  height: 20,
                  cursor: 'pointer',
                  color: '#000',
                }}
              />
            </div>
          </div>
        </Dropdown>
      </div>
    </>
  )
}

MainHeaderBar.propTypes = {
  title: PropTypes.string,
}

export default memo(
  withRouter(
    inject(
      'authenticationStore',
      'accountStore',
      'userStore',
      'companyStore',
      'notificationStore',
      'loadingAnimationStore',
      'commonStore',
      'taskManagementStore',
      'taskManagementCommentStore'
    )(observer(MainHeaderBar))
  )
)
